import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import {
  StrapiComponentFeatureHero,
  StrapiTextSubText,
} from '../section/interfaces';
import { BackgroundValue, getBackground } from '@/theme/backgrounds';
import {
  TextWithDropShadow,
  TextWithDropShadowColor,
} from '../TextWithDropShadow';

interface Props {
  props: Partial<StrapiComponentFeatureHero>;
  className?: string;
  children?: ReactNode;
}

export const FeatureHero: FC<Props> = ({
  props: {
    text,
    data,
    rounded = false,
    background,
    padding,
    minHeight,
    orientation,
    textPosition,
  },
  className,
}) => {
  const textColor = (item: StrapiTextSubText): TextWithDropShadowColor => {
    const twColor =
      item.color?.TWName && item.color?.TWWeight
        ? `text-${item.color?.TWName}-${item.color?.TWWeight}`
        : undefined;

    return {
      text: twColor || item?.color?.color || 'text-white',
      shadow: 'text-white',
    };
  };

  const textSize = (item: StrapiTextSubText): string =>
    item?.size?.size.match(/\d+/)?.[0] || '3';

  const contentAlignmanet =
    textPosition === 'middle'
      ? 'items-center  justify-center'
      : textPosition === 'top'
        ? 'items-start justify-start'
        : 'items-end justify-end';

  const paddingClass =
    padding &&
    `p-0 pt-${padding.top} pr-${padding.right} pb-${padding.bottom} pl-${padding.left} `;

  const heightClass = minHeight ? `min-${minHeight.value}` : '';

  const backgroundStyle = background?.style
    ? { background: getBackground(background?.style as BackgroundValue) }
    : { background: '' };

  return (
    <div
      className={twMerge(
        'mrc-info-card-banner flex',
        contentAlignmanet,
        className,
        clsx(paddingClass),
        clsx(heightClass),
        rounded && 'rounded-3xl'
      )}
    >
      <div
        className={`flex w-full ${orientation === 'image-bottom' ? 'flex-col' : 'flex-col-reverse'} gap-y-6 p-7 pb-0 text-center`}
      >
        {text &&
          text.map((item, index) => (
            <TextWithDropShadow
              key={index}
              text={item.text}
              color={textColor(item)}
              displayShadow={item.shadow}
            />
          ))}

        <div
          style={backgroundStyle}
          className='flex min-h-[200px] justify-center rounded-3xl'
        >
          <img
            src={background?.url}
            alt='Controller Image'
            width={640}
            height={854}
          />
        </div>
      </div>
    </div>
  );
};
